/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {CaseReducer, PayloadAction} from "@reduxjs/toolkit";
import {IWizardState} from "./slices";

export const setWizardOpen: CaseReducer<IWizardState, PayloadAction<boolean>> = (state, action) => {
  state.isWizardOpen = action.payload
}
